const employeesStyle = {
  root: {
    flexGrow: 1,
  },
  newEmployee: {
    display: 'flex',
    flexDirection: 'row',
  },
  newEmployeeSelect: {
    marginTop: '10px',
    width: '600px',
  },
  inviteBtn: {
    marginTop: '10px',
    marginLeft: '10px',
    height: '35px',
  },
  fieldSpacing: {
    marginTop: '10px',
  },
  leftHeading: {
    textAlign: 'left',
    marginTop: '20px',
    marginBottom: '20px',
  },
  table: {
    marginTop: '40px',
    marginBottom: '250px',
  },
  button: {
    marginTop: '40px',
    marginBottom: '20px',
    float: 'left',
    borderRadius: '80',
    color: 'primary',
  },
}

export default employeesStyle
